module.exports = __webpack_public_path__ + "./images/58e650c11dc438be2920ae899a3f433a.webp";